var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentVerySatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9835 3.33301C10.7835 3.33301 3.3335 10.783 3.3335 19.9997C3.3335 29.2163 10.7835 36.6663 19.9835 36.6663C29.1835 36.6663 36.6668 29.2163 36.6668 19.9997C36.6668 10.783 29.2002 3.33301 19.9835 3.33301ZM20.0002 33.333C12.6335 33.333 6.66683 27.3663 6.66683 19.9997C6.66683 12.633 12.6335 6.66634 20.0002 6.66634C27.3668 6.66634 33.3335 12.633 33.3335 19.9997C33.3335 27.3663 27.3668 33.333 20.0002 33.333ZM21.6668 16.5663L23.4335 18.333L25.2002 16.5663L26.9668 18.333L28.7335 16.5663L25.2002 13.033L21.6668 16.5663ZM14.8002 16.5663L16.5668 18.333L18.3335 16.5663L14.8002 13.033L11.2668 16.5663L13.0335 18.333L14.8002 16.5663ZM20.0002 29.1663C23.8835 29.1663 27.1835 26.733 28.5168 23.333H11.4835C12.8168 26.733 16.1168 29.1663 20.0002 29.1663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentVerySatisfied);
export default __webpack_public_path__ + "static/media/sentiment_very_satisfied.400a7af939fb2aca143c83d2966418f0.svg";
export { ForwardRef as ReactComponent };